import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import {
  BaseOfferingCard,
  PremiumSessionCourseCard,
} from 'components/OfferingCards';
import LiveEventsCard from 'components/OfferingCards/LiveEventsCard';
import { extractFromSlug } from 'helpers/utils';
import { LiveEvent } from 'types';
import { CommonLaneProps } from './types';

type LiveEventsLaneProps = CommonLaneProps & {
  liveEvents: LiveEvent[];
};

const LiveEventsLane = ({
  expanded,
  liveEvents,
  onTitleClick,
}: LiveEventsLaneProps) => {
  const { t } = useTranslation();
  const { catalogStore, premiumSessionsStore } = useMobxStores();

  const { premiumSessionAggregateMap } = premiumSessionsStore;

  const renderItem = (entry: LiveEvent) => {
    if (entry.type === 'premvt') {
      const [code, version] = entry.slug.split('-');
      const slug = `${code}-${version}`;
      const aggregate = premiumSessionAggregateMap.get(slug);

      return <PremiumSessionCourseCard premiumSessionAggregate={aggregate} />;
    }

    if (entry.type === 'lvc') {
      const { code } = extractFromSlug(entry.slug);
      const catalogEntry = catalogStore.entriesByCode[code] || null;

      return <BaseOfferingCard coursesShowLiveClassInfo entry={catalogEntry} />;
    }

    if (entry.type === 'vt' || entry.type === 'ilt') {
      return <LiveEventsCard liveEventInfo={entry} />;
    }

    return null;
  };

  return (
    <OfferingCardLane
      className="new_lane"
      expanded={expanded}
      items={liveEvents}
      onTitleClick={onTitleClick}
      renderItem={renderItem}
      title={t('Live events')}
    />
  );
};

export default observer(LiveEventsLane);
